import { render, staticRenderFns } from "./FooterVue.vue?vue&type=template&id=4ce63d53&scoped=true"
import script from "./FooterVue.vue?vue&type=script&lang=js"
export * from "./FooterVue.vue?vue&type=script&lang=js"
import style0 from "./FooterVue.vue?vue&type=style&index=0&id=4ce63d53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce63d53",
  null
  
)

export default component.exports